// extracted by mini-css-extract-plugin
export default {"root":"C8HAf9es","breadcrumb_list":"ahHyU2S9","link":"ITq4BTXR","goBack":"ERB5_CTi","backSvg":"gwFTyVus"};